import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Login',
    setup() {
        const img404 = require('@/assets/images/image-404-view.png');
        return {
            img404
        } 
    }
});
